import axios from "axios";

const axiosInstance = axios.create({
  // baseURL: "https://crm.shikhya.org/TeacherAppApiNew/",
  baseURL: " https://api.school-dashboard.avetilearning.com/",
  // baseURL: "http://avetitest.shikhya.org/TeacherAppApiNew",
  // baseURL: "http://avetitest.ankitrajmahapatra.rocks/TeacherAppApiNew",

  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosInstance;
